
import { Container} from '@mui/material'
// import { useRouter } from "next/router"


import uiConfig from "../fuiconfig"
import app from "../firebase";
import "firebase/compat/auth"
import StyledFirebaseAuth from "./StyledFirebaseAuth"

// import { Link, useHistory } from "react-router-dom"

// const useStyles = makeStyles((theme) => ({
//   field: {
//     marginBottom: 40,
//   },
//   container: {
//     padding: theme.spacing(5)
//   }
// }));

// const theme = createMuiTheme({
//   typography: {
//     htmlFontSize: 10,
//     // pxToRem: size => `${(size / htmlFontSize) * coef}rem`,
//   }
// })

export default function LoginForm() {
  // const classes = useStyles();

  return (
    // <Container className={classes.container}>      
    <Container>      
      <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={app.auth()} />
    </Container>
  );

//   const history = useHistory();

//   // Instead of of useRef() I use state. which one is better ? TODO
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const { login, currentUser } = useAuth();
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
// //   const history = useHistory()

//   useEffect(() => {
//     if(currentUser) {
//       history.push("/");
//     }
//   }, [currentUser])

//   async function handleSubmit(e) {
//     e.preventDefault()

//     // if (passwordRef.current.value !== passwordConfirmRef.current.value) {
//     //   return setError("Passwords do not match")
//     // }

//     // const email = emailRef.current.value;
//     // const password = passwordRef.current.value;

//     // const email = "test.test@test.test";
//     // const password = "12345678";

//     try {
//       setError("");
//       setLoading(true);
//       //validation
//       if (email && password) {
//         // submission 
//         await login(email, password);
//         console.log("login to the account has succeed");
//         // history.push("/"); // moved to useEffect
//       } else {
//         console.log("Input not valid");
//         setError("Input not valid");
//       }      
//     } catch {      
//       setError("Failed to login to an account")
//       console.log("login to the account has failed");
//     }

//     setLoading(false);
//   }

//   return (
//       // <ThemeProvider theme={theme}>
//       <Grid
//         container
//         spacing={0}
//         direction="column"
//         alignItems="center"
//         justify="center"
//         style={{ minHeight: '80vh' }}
//       >

//         <Grid item xs={4}>
//           {/* <form noValidate autoComplete="off" onSubmit={handleSubmit}> */}
//           <form noValidate autoComplete="on" onSubmit={handleSubmit}>
//             <TextField 
//               onChange={(e) => setEmail(e.target.value)}
//               label="Email" 
//               type="email"
//               className={classes.field}
//               required 
//               fullWidth 
//               variant="outlined"
//             />
//             <TextField 
//               onChange={(e) => setPassword(e.target.value)}
//               label="Password"
//               type="password"
//               className={classes.field}
//               required
//               fullWidth
//               variant="outlined"
//             />
//             <Button             
//               type="submit"
//               variant="contained" 
//               color="primary"
//               disabled={loading}
//               fullWidth
//             >
//               Log In
//             </Button>
//           </form>
//         </Grid>   
//       </Grid> 
//       // </ThemeProvider>
//   )
}